import { ProGalleryItemDecorator } from './ProGalleryItemDecorator';
import { AppViewerOverrides } from '../types';
import { ProGalleryApp as app } from './app';

export const ProGalleryAppUI: AppViewerOverrides = {
  documentType: app.documentType,
  ItemDecoration: ProGalleryItemDecorator,
};
